import React, { useState } from 'react';
import { Box, Flex, Text, Modal } from '../neta';
import { colors } from '../../styles/theme';

export default function Disclosure() {
  let [show = false, setShow] = useState(0);
  return (
    <>
      <Box textAlign="right">
        <Text.caption
          color="primary"
          style={{ cursor: 'pointer' }}
          onClick={() => setShow(true)}
        >
          Advertising Disclosure
        </Text.caption>
      </Box>
      {show ? (
        <Modal isOpen onClose={() => setShow(false)}>
          {() => (
            <Flex bg={colors.grayscale.gypsum} p={3} my={6} mx={3}>
              <Text.caption
                style={{ lineHeight: 1.5 }}
                color={colors.grayscale.stone}
                lineHeight={1}
              >
                From time to time, we may share, link or recommend products and services
                that we’ve found to be helpful. It’s important to note that we may receive
                monetary compensation or other types of remuneration for our endorsements,
                testimonials or recommendations. Even in those instances, it in no way
                affects our recommendations and advice, which are always based on research
                conducted by our team.
              </Text.caption>
            </Flex>
          )}
        </Modal>
      ) : null}
    </>
  );
}
